export default "__VITE_ASSET__OU3MBJZX__"